import "./App.css";

import { Routes, Route, useNavigate } from "react-router-dom";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Dashboard from "./pages/dashboard/Dashboard";
import Navbar from "./components/navbar/Navbar";
import CalendarClassRoom from "./components/calendar/Calendar";
import Login from "./pages/Login";
import MainClass from "./pages/mainClass/MainClass";
import TrainerTab from "./components/trainerTab/TrainerTab";
import CreateLiveSession from "./components/createLiveSession/CreateLiveSession";
import CreateAssignmentPage from "./components/createAssignmentPage/CreateAssignmentPage";
import UploadMaterialPage from "./components/uploadMaterialPage/UploadMaterialPage";
import CreateTopicPage from "./components/createTopic/CreateTopicPage";
import OTPPopup from "./components/otpPopup/OTPPopup";
import ForgotPassword from "./components/forgotPassword/ForgotPassword";
import JoinClass from "./components/joinClass/JoinClass";
import Courses from "./pages/courses/Courses";
import StudentDashboard from "./pages/student/StudentDashboard";
import StudentViewCourses from "./pages/student/StudentViewCourses";
import StudentMyCourses from "./pages/student/StudentMyCourses";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ClassesPage from "./pages/admin/setup/ClassesPage";
import ClassesDashbord from "./pages/admin/AllClasses/ClassesDashbord";
import TrainerSetUpPage from "./pages/admin/setup/trainers/TrainerSetUpPage";
import TrainerDashboard from "./pages/dashboard/TrainerDashboard";
import StudentDemosList from "./components/demos/student/StudentDemosList";
import StudentDemoPage from "./pages/demos/StudentDemoPage";
import AdminDemosPage from "./pages/admin/AllDemos.jsx/AdminDemosPage";
import TrainerClasses from "./pages/trainer/TrainerClasses";
import StudentMyProfile from "./pages/student/StudentMyProfile";
import BlogPage from "./pages2/CoursesPage";
import CoursePayment from "./sections2/dashboard/course/CourseDetails";
import StudentPayment from "./pages/student/StudentPayment";
import StudentGrades from "./pages/student/StudentGrades";
import StudentCalendar from "./pages/student/StudentCalendar";
import ExpertCall from "./sections2/call/ExpertCall";
import LeadCreatePop from "./components/leadcreatepopup/LeadCreatePopup";
import CoursesDetailsPage from "./pages/courses/CoursesDetailsPage";
import Login2 from "./pages/Login2";
import Login3 from "./pages/Login3";
import TrainerMyProfile from "./pages/trainer/TrainerMyProfile";
import TrainerDemos from "./pages/trainer/TrainerDemos";
import TrainerManageStudents from "./pages/trainer/TrainerManageStudents";
import StudentProfilePage from "./pages/trainer/StudentProfilePage";
import { useSelector } from "react-redux";
import Layout from "./layout/Layout";
import HomePage from "./pages/courses2/HomePage";
import SingleCoursePage from "./pages/courses2/SingleCoursePage";
import Course from "./components/course/Course";
import CoursesPage from "./pages/courses2/CoursesPage";
import CartPage from "./pages/courses2/CartPage";
import TrainerEnquiries from "./pages/trainer/TrainerEnquiries";
import { useEffect } from "react";
import StudentDashboard2 from "./pages/student2/StudentDashboard2";
import StudentGrades2 from "./pages/student2/StudentGrades2";
import StudentViewCourses2 from "./pages/student2/StudentViewCourses2";
import StudentStudyMaterial from "./pages/student2/studentStudyMaterial";
import StudentTests from "./pages/student2/StudentTests";
import StudentLayout from "./layout/student/StudentLayout";
import StudentClassSearch from "./pages/student2/StudentClassSearch";
import StudentViewDemos from "./pages/student2/StudentViewDemos";
import MainPage from "./newTestPreo/courses/MainPage";
import CourseDescription from "./newTestPreo/courses/CourseDescription";
import Login5 from "./newTestPreo/pages/authentication/SignIn";
import LandingPage from "./newTestPrepDesign/landingPage/LandingPage";
import StepperForm from "./newTestPrepDesign/getStarted/ExamType";
import Page404 from "./pages/Page404";
import Page500 from "./pages/Page500";
import CheckoutPage from "./pages/CheckoutPage";
import Calendar from "./newTestPrepDesign/component/AttendanceCalendar";
import AttendancePage from "./pages/AttendancePage";
import ClassInformation from "./newTestPreo/courses/ClassInformation";
import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import MainLayout from "./newTestPrepDesign/layout/MainLayout";
import themes from "./newTestPrepDesign/themes";
import NavigationScroll from "./newTestPrepDesign/layout/NavigationScroll";
import MyTestPage from "./newTestPrepDesign/test/MyTestPage";
import MyPaymentsPage from "./newTestPreo/pages/payment/MyPaymentsPage";
import BarChart from "./newTestPrepDesign/component/BarChart";
import EvaluationTest from "./newTestPreo/components/EvaluationTest/EvaluationTest";
import Quiz from "./newTestPreo/components/EvaluationTest/Quiz1";
import Phone from "./newTestPreo/components/EvaluationTest/Phone";
import InvoiceForm from "./newTestPreo/pages/payment/Invoice/InvoiceForm";
import EnrolledClasses from "./newTestPrepDesign/pages/EnrolledClasses";
import ViewClassDetails from "./newTestPrepDesign/pages/ViewClassDetails";
import ViewAttendance from "./newTestPrepDesign/pages/ViewAttendance";
import EvaluationPDF from "./newTestPrepDesign/pages/demos/ViewDemoEvaluation";
import ForgotPassword2 from "./newTestPreo/pages/authentication/forgotPassword/ForgotPassword";
import StudentMyPayment from "./newTestPrepDesign/pages/StudentMyPayment";
import StudentQRCode from "./newTestPrepDesign/pages/studentqrcode/StudentQRCode";
import BasicRegistration from "./newTestPreo/pages/studentRegistration/BasicRegistration";
import FinalRegistrationPage from "./newTestPreo/pages/studentRegistration/FinalRegistration";
import ThankYouPage from "./newTestPreo/pages/studentRegistration/ThankYouPage";
import EventRegistrationUi from "./pages/eventRegistrationUi/EventRegistrationUi";
import EventThankYouPage from "./pages/eventRegistrationUi/EventThankYouPage";
import SignUpPage from "./pages/loginAndSignUp/newSignUpForm/SignUpPage";
import LoginPageForm from "./pages/loginAndSignUp/newLoginForm/LoginPageForm";
import TermsOfUse from "./pages/TermsOfUsePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import RefundAndCancellationPage from "./pages/RefundPolicyPage";
import ContactUsPage from "./pages/ContactUsPage";
import DashboardLayout from "./SAPPages/pages/layout/DashboardLayout";
import SAPDashboard from "./SAPPages/pages/dashboard/SAPDashboard";
import LoginPage2 from "./SAPPages/pages/authentication/LoginPage2";
import RegisterPage2 from "./SAPPages/pages/authentication/RegisterPage2";
import NewTestPrepDashboard from "./STMPages/pages/testPrepDashboard/NewTestPrepDashboard";
import SAPDashboardLayout from "./SAPPages/pages/layout/DashboardLayout";
import TestTypeContent from "./STMPages/pages/testPrepDashboard/content/TestTypeContent";
import IeltsTestType from "./STMPages/pages/testPrepDashboard/TesttypecontentPages/IeltsTestType";
import TofleTestContent from "./STMPages/pages/testPrepDashboard/TesttypecontentPages/TofleTestContent";
import PteTestContent from "./STMPages/pages/testPrepDashboard/TesttypecontentPages/PteTestContent";
import GrePagecontent from "./STMPages/pages/testPrepDashboard/TesttypecontentPages/GrePagecontent";
import GmatContent from "./STMPages/pages/testPrepDashboard/TesttypecontentPages/GmatContent";
import SatContent from "./STMPages/pages/testPrepDashboard/TesttypecontentPages/SatContent";
import SapContennt from "./STMPages/pages/testPrepDashboard/content/sapcontent/SapContennt";
import PersonalDetailsForm from "./SAPPages/pages/registrationform/PersonalDetailsForm";
import QuizMainLayout from "./SAPPages/pages/dashboard/PersonalityQuiz";
import AllTestPrepClasses from "./STMPages/pages/allClasses/AllTestPrepClasses";
import SAP_Courses from "./SAPPages/pages/courses/SAP_Courses";
import SAP_WishList from "./SAPPages/pages/wishList/SAP_WishList";
import TestPrepWishList from "./STMPages/pages/wishlist/TestPrepWishList";
import TestPrepDashboardLayout from "./STMPages/pages/layout/TestPrepDashboardLayout";
import NewPage404 from "./STMPages/pages/errorpages/NewPage404";
import NoCoursesFound from "./SAPPages/pages/courses/NoCoursesFound";
import NewPage403 from "./STMPages/pages/errorpages/NewPage403";
import NewPage405 from "./STMPages/pages/errorpages/NewPage500";
import ConnectionLostPage from "./STMPages/pages/errorpages/ConnectionLostPage";
import ViewDemoHistory from "./STMPages/pages/demoPages/ViewDemoHistory";
import ProfilePage from "./SAPSTMPages/pages/ProfilePage";
import PricingPlan from "./SAPPages/pages/pricingplan/PricingPlan";
import SAP_TimeLine from "./SAPPages/pages/timeLine/SAP_TimeLine";
import Customize_Timeline from "./SAPPages/pages/timeLine/Customize_Timeline";
import PremiumAccess from "./SAPPages/components/PremiumAccess/PremiumAccess";
import ViewEvaluationPdf from "./STMPages/pages/demoPages/ViewEvaluationPdf";
import NewPage500 from "./STMPages/pages/errorpages/NewPage500";
import NewPage400 from "./STMPages/pages/errorpages/NewPage400";
import AllPackagesPage from "./SAPPages/pages/pricingplan/AllPackagesPage";
import StepOne from "./STMPages/pages/testPrepEnrolment/ClassDetailsAndPackage";
import SAP_Checkout from "./SAPPages/pages/checkout/SAP_Checkout";
import ClassDetailsAndPackage from "./STMPages/pages/testPrepEnrolment/ClassDetailsAndPackage";
import TestPrepCheckout from "./STMPages/pages/testPrepEnrolment/checkout/TestPrepCheckout";
import TestPrepClassroom from "./STMPages/pages/classrooom/TestPrepClassroom";
import Terms_Conditions from "./SAPPages/components/Terms_Conditions";
import MoreInfoPopup from "./SAPPages/pages/pricingplan/MoreInfoPopup";
import SelectedClassDetails from "./STMPages/pages/classrooom/selectedClassDetails/SelectedClassDetails";
import ViewSelectedClassAttendanceDetails from "./STMPages/pages/classrooom/attendance/ViewSelectedClassAttendanceDetails";
import PerFormanceReport from "./STMPages/pages/classrooom/performanceReport/PerFormanceReport";
import SelectedTestPerformanceDetails from "./STMPages/pages/classrooom/performanceReport/SelectedTestPerformanceDetails";
import ViewPaymentHistory from "./STMPages/pages/paymentHistory/ViewPaymentHistory";
import ViewPaymentInvoice from "./STMPages/pages/paymentHistory/ViewPaymentInvoice";
import SAP_Payment_History from "./SAPPages/pages/paymentHistory/SAP_Payment_History";
import FinalPerformancePage from "./STMPages/pages/performance/FinalPerformancePage";
import MyExamFinalPage from "./STMPages/pages/performance/MyExamFinalPage";
import TakeExamPage from "./STMPages/pages/realtest/TakeExampage";
import PurchaseTest from "./STMPages/pages/performance/purchaseTest/pages/PurchaseTest";
import MyExamCart from "./STMPages/pages/performance/purchaseTest/pages/MyExamCart";
import PurchaseTestCheckout from "./STMPages/pages/performance/purchaseTest/pages/checkout/PurchaseTestCheckout";
import SAP_Applications from "./SAPPages/pages/applications/SAP_Applications";
import RoadmapIntro from "./SAPPages/pages/timeLine/RoadmapIntro";
import PersonalityResultCard from "./SAPPages/pages/timeLine/PersonalityResultCard";
import ApplicationDetails from "./SAPPages/pages/applications/ApplicationDetails";
import SAP_Documents from "./SAPPages/pages/documents/SAP_Documents";
import { socket } from "./socket";
import CourseDetails from "./SAPPages/pages/courses/courseDetails/CourseDetails";
import TimelineSelector from "./SAPPages/pages/timeLine/TimelineSelector";
import QuarterTimeline from "./SAPPages/pages/timeLine/SAP_CustomizedTimeline";
import OtherCareerInterest from "./SAPPages/pages/timeLine/OtherCareerInterest";
import SAP_EnrolledPrograms from "./SAPPages/pages/enrolledPrograms/SAP_EnrolledPrograms";
import SAP_AutomatedTimeline from "./SAPPages/pages/timeLine/SAP_AutomatedTimeline";
import LessonDayDetails from "./STMPages/pages/classrooom/selectedClassDetails/LessonDayDetails";
import SAP_Task_Progress from "./SAPPages/pages/timeLine/SAP_Task_Progress";
function App() {
  const theme = createTheme();
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    if (userId) {
      socket.connect();

      socket.emit("join", {
        userId: userId,
      });
    }

    return () => {
      socket.disconnect();
    };
  }, [userId]);

  return (
    <>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themes}>
          <CssBaseline />
          <NavigationScroll>
            <Routes>
              <Route path="/confirmation" element={<Phone />} />
              <Route
                path="/basic-registration"
                element={<BasicRegistration />}
              />
              <Route path="/registration" element={<FinalRegistrationPage />} />
              <Route path="/thank-you" element={<ThankYouPage />} />
              <Route
                path="/event-registration"
                element={<EventRegistrationUi />}
              />
              <Route
                path="/registration-thank-you"
                element={<EventThankYouPage />}
              />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route
                path="/refund-and-cancellation-policy"
                element={<RefundAndCancellationPage />}
              />
              <Route path="/contact-us" element={<ContactUsPage />} />

              {/* New Routes */}
              <Route path="/" element={<RegisterPage2 />} />
              <Route path="/login" element={<LoginPage2 />} />
              <Route
                path="/registrationform"
                element={<PersonalDetailsForm />}
              />
              <Route path="/personality-quiz" element={<QuizMainLayout />} />
              <Route path="/page404" element={<NewPage404 />} />
              <Route path="/page403" element={<NewPage403 />} />
              <Route path="/page500" element={<NewPage500 />} />
              <Route path="/page400" element={<NewPage400 />} />
              <Route path="/network-error" element={<ConnectionLostPage />} />
              <Route
                path="/test-prep/evaluation-report/:evaluationId"
                element={<ViewEvaluationPdf />}
              />
              <Route
                path="/termsAndConditions"
                element={<Terms_Conditions />}
              />
              <Route
                path="/view-payment-receipt"
                element={<ViewPaymentInvoice />}
              />
              <Route
                path="/sap/*"
                element={
                  <SAPDashboardLayout>
                    <Routes>
                      <Route path="/dashboard" element={<SAPDashboard />} />
                      <Route path="/courses" element={<SAP_Courses />} />
                      <Route path="/wishlist" element={<SAP_WishList />} />
                      <Route path="/noCourses" element={<NoCoursesFound />} />
                      <Route path="/profile" element={<ProfilePage />} />
                      <Route path="/pricing-plan" element={<PricingPlan />} />
                      <Route path="/timeline" element={<SAP_TimeLine />} />
                      <Route path="/calc" element={<MoreInfoPopup />} />
                      <Route path="/checkout" element={<SAP_Checkout />} />
                      <Route
                        path="/customize-timeline"
                        element={<Customize_Timeline />}
                      />
                      <Route path="/report" element={<PremiumAccess />} />
                      <Route path="/packages" element={<AllPackagesPage />} />
                      <Route
                        path="/payment-history"
                        element={<SAP_Payment_History />}
                      />
                      <Route
                        path="/applications"
                        element={<SAP_Applications />}
                      />
                      <Route
                        path="/applications-details"
                        element={<ApplicationDetails />}
                      />
                      <Route path="/documents" element={<SAP_Documents />} />
                      <Route path="/roadmap-intro" element={<RoadmapIntro />} />
                      <Route path="/prc" element={<PersonalityResultCard />} />
                      <Route
                        path="/automated"
                        element={<SAP_AutomatedTimeline />}
                      />
                      <Route path="/customized" element={<QuarterTimeline />} />
                      <Route
                        path="/select-timeline"
                        element={<TimelineSelector />}
                      />
                      <Route
                        path="/other-career-interest"
                        element={<OtherCareerInterest />}
                      />
                      <Route
                        path="/courses/course-details/:courseId"
                        element={<CourseDetails />}
                      />
                      <Route
                        path="/enrolled-programs"
                        element={<SAP_EnrolledPrograms />}
                      />
                      <Route
                        path="/task-progress"
                        element={<SAP_Task_Progress />}
                      />
                    </Routes>
                  </SAPDashboardLayout>
                }
              />
              <Route
                path="/test-prep/*"
                element={
                  <TestPrepDashboardLayout>
                    <Routes>
                      <Route
                        path="/testprepdashboard"
                        element={<NewTestPrepDashboard />}
                      />
                      <Route path="/testinfo" element={<TestTypeContent />} />
                      <Route path="/sapinfo" element={<SapContennt />} />
                      <Route path="/classes" element={<AllTestPrepClasses />} />
                      <Route path="/wishlist" element={<TestPrepWishList />} />
                      <Route path="/demos" element={<ViewDemoHistory />} />
                      <Route path="/profile" element={<ProfilePage />} />
                      <Route path="/packages" element={<StepOne />} />
                      <Route
                        path="/packages"
                        element={<ClassDetailsAndPackage />}
                      />
                      <Route path="/checkout" element={<TestPrepCheckout />} />
                      <Route
                        path="/classroom"
                        element={<TestPrepClassroom />}
                      />
                      <Route
                        path="/class-details/:std_class_detail_id"
                        element={<SelectedClassDetails />}
                      />
                      <Route
                        path="/attendance-details/:std_class_detail_id"
                        element={<ViewSelectedClassAttendanceDetails />}
                      />
                      <Route
                        path="/performance-details/:std_class_detail_id"
                        element={<SelectedTestPerformanceDetails />}
                      />
                      <Route
                        path="/payment-history"
                        element={<ViewPaymentHistory />}
                      />
                      <Route
                        path="/performance"
                        element={<FinalPerformancePage />}
                      />
                      <Route
                        path="/performance/my-exam"
                        element={<MyExamFinalPage />}
                      />
                      <Route
                        path="/performance/purchase-test"
                        element={<PurchaseTest />}
                      />
                      <Route path="/my-exam-cart" element={<MyExamCart />} />

                      <Route
                        path="/performance/purchase-test/checkout"
                        element={<PurchaseTestCheckout />}
                      />

                      <Route path="/myqrcode" element={<StudentQRCode />} />
                      <Route
                        path="/lesson/:planId/:dayNumber"
                        element={<LessonDayDetails />}
                      />
                    </Routes>
                  </TestPrepDashboardLayout>
                }
              />
            </Routes>
          </NavigationScroll>
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
}

export default App;
